var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.enable)?_c('div',{staticStyle:{"margin-bottom":"1em"},style:({'font-family':_vm.item.font,'font-size':_vm.item.fontSize})},[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.item.text)+"\n    ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }